import { render, staticRenderFns } from "./VouchersDashboard.vue?vue&type=template&id=e18d7ab0&"
import script from "./VouchersDashboard.vue?vue&type=script&lang=js&"
export * from "./VouchersDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports